module.exports = {"469005100":"文城镇","469005101":"重兴镇","469005102":"蓬莱镇","469005103":"会文镇","469005104":"东路镇","469005105":"潭牛镇","469005106":"东阁镇","469005107":"文教镇","469005108":"东郊镇","469005109":"龙楼镇","469005110":"昌洒镇","469005111":"翁田镇","469005112":"抱罗镇","469005113":"冯坡镇","469005114":"锦山镇","469005115":"铺前镇","469005116":"公坡镇","469005400":"国营东路农场","469005401":"国营南阳农场","469005402":"国营罗豆农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469005.json
// module id = 2022
// module chunks = 0